// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import { isInProduct } from '../utils/inProduct.js';

// Local Functions
const getIsInProductMagazine = createSelector(get('router'), ({ location }) =>
  isInProduct(location),
);

// Module Exports
export { getIsInProductMagazine };
